module.exports = __webpack_public_path__ + "img/rp-logo.6a92037e.png";